import React from "react";
import { formatDateTime } from "../../../../utils";
import InfoBlock from "../../../common/InfoBlock";

const CampaignActionDetails = ({
  actionList,
  status,
  header = "Campaign Pause Details",
  timeZone,
}) => {
  const statusChanges = actionList.filter((changes) => changes.status === status);

  if (statusChanges?.length === 0) return null;

  return (
    <InfoBlock
      header={header}
      config={statusChanges.map((action) => [
        {
          title: "Date Range",
          // No toDate means no resume date yet, so only the start date is shown.
          value: [
            formatDateTime(action.fromDate, "MMM DD, YYYY", false, timeZone),
            formatDateTime(action.toDate, "MMM DD, YYYY", false, timeZone),
          ]
            .filter(Boolean)
            .join(" to "),
          size: {
            lg: 4,
            md: 4,
            sm: 4,
          },
        },
        {
          title: "Reason",
          value: action.reason,
          size: {
            lg: 4,
            md: 4,
            sm: 4,
          },
        },
        {
          title: "Notes",
          value: action.notes,
          size: {
            lg: 4,
            md: 4,
            sm: 4,
          },
        },
      ])}
    />
  );
};

export default CampaignActionDetails;
